"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReactElement = exports.isAxiosError = void 0;

function isAxiosError(response) {
  /**
   *	We’re having to use a nested type guard
   *	otherwise TS and eslint will throw an error saying
   *	`Property 'isAxiosError' does not exist on type 'object'.`
   */
  var hasAxiosError = function hasAxiosError(o) {
    return "isAxiosError" in o;
  };

  if (response !== null && typeof response == "object" && hasAxiosError(response) && response.isAxiosError === true) {
    return response.isAxiosError;
  } else return false;
}

exports.isAxiosError = isAxiosError;

function isReactElement(child) {
  var hasTypeProperty = function hasTypeProperty(o) {
    return "type" in o;
  };

  var hasPropsProperty = function hasPropsProperty(o) {
    return "props" in o;
  };

  if (child !== null && typeof child === "object" && hasTypeProperty(child) && hasPropsProperty(child)) {
    return true;
  } else return false;
}

exports.isReactElement = isReactElement;